module.exports = __webpack_public_path__ + "media/images/toilet@2x-7b3e1980949b0c4f30ee72241466e413.jpg";